import logger from "../../../utils/logger";

/**
 * A date formatting function for table cells
 * @param {Object} rowData - Row data containing the date value
 * @param {string} dataKey - Data key to extract from row data
 */
function DateColumn({ dataKey, rowData }) {
  const value = rowData[dataKey];
  if (value) {
    try {
      return new Date(value).toLocaleDateString("en-NZ", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch (e) {
      logger.error("Error formatting date:", value, e);
      return "Invalid Date";
    }
  }
  return value !== null && value !== undefined ? String(value) : "N/A";
}

export default DateColumn;
